import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import messageDetailModel from './messageDetailModel.vue';
import { messageDetail } from '@/api/notice.js';
import { analyzVariable } from './util';
export default {
  data() {
    return {
      allMessageList: [],
      messageDetailData: {},
      timer: null
    };
  },
  computed: {
    ...mapState({
      popMessageList: state => state.message.popMessageList,
      userInfo: state => state.user.userInfo,
      messageDetailVisible: state => state.message.messageDetailVisible,
      forceMessageModelVisible: state => state.message.forceMessageModelVisible,
      resetPasswordModelVisible: state => state.user.resetPasswordModelVisible
    })
  },
  components: {
    messageDetailModel
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
    this.$notification.destroy();
  },
  mounted() {
    this.exchangeLanguage();
  },
  methods: {
    remove(item) {
      let index = this.allMessageList.findIndex(i => i.id === item.id);
      this.allMessageList.splice(index, 1);
    },
    popAllMessageList() {
      setInterval(() => {
        if (this.allMessageList.length > 0) {
          this.allMessageList.shift();
        }
      }, 5 * 1000);
    },
    setNotification(item) {
      let content = item.content.replace(/<[^>]+>/g, '');
      content = analyzVariable(content);
      if (document.querySelector('#messge-container')) {
        this.$notification.open({
          message: item.title,
          key: item.id,
          description: h => {
            return h('div', {
              domProps: {
                innerHTML: content
              },
              style: 'width: 100%;height:24px;line-height:24px;overflow: hidden;text-overflow: ellipsis;white-space:nowrap;word-break: break-all;'
            }
            // item.content
            );
          },
          time: h => {
            return h('div', {}, item.receptionTime);
          },
          onClick: () => {
            //点击弹出详情弹窗
            this.messageDetailData = JSON.parse(JSON.stringify(item));
            messageDetail({
              messageDetailId: item.id
            }).then(res => {
              this.$store.dispatch('message/getUnReadCount');
            });
          },
          onClose: () => {
            let index = this.allMessageList.findIndex(i => i.id === item.id);
            this.allMessageList.splice(index, 1);
          },
          style: {
            zIndex: 1140,
            cursor: 'pointer'
          },
          top: '100px',
          class: 'message-pop',
          duration: 0,
          getContainer: () => {
            return document.querySelector('#messge-container');
          }
        });
        setTimeout(() => {
          //消失后删除allMessageList组内数据
          let index = this.allMessageList.findIndex(i => i.id === item.id);
          this.allMessageList.splice(index, 1);
          this.$notification.close(item.id);
        }, 5000);
      }
    },
    exchangeLanguage() {
      this.timer = setInterval(() => {
        if (this.allMessageList.length < 5 && this.popMessageList.length > 0 && !this.messageDetailVisible && !this.forceMessageModelVisible && !this.resetPasswordModelVisible) {
          if (document.querySelector('#messge-container')) {
            this.allMessageList.push(this.popMessageList[0]);
            this.setNotification(this.popMessageList[0]);
            this.$store.commit('message/REMOVE_POP_MESSAGE_LIST');
          }
        }
      }, 200);
    }
  }
};